import * as React from 'react';
import { FieldHookConfig, useField } from 'formik';
import { SelectInputProps } from '@material-ui/core/Select/SelectInput';
import {
  checkFormHasError,
  handleBlurFormField,
  handleChangeFormSelectField,
} from '@tock/shared/ui/forms/formHelpers';
import { omit } from 'es-toolkit/compat';
import SelectField, { SelectProps } from 'omakase/FormControls/SelectField';

const FormSelectField: React.FunctionComponent<SelectProps> = ({
  children,
  helperText,
  onChange,
  onBlur,
  ...rest
}) => {
  const idValue = rest.id ?? rest.name;

  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  const [fieldConfig, meta] = useField(rest as FieldHookConfig<any>);
  const handleChange: SelectInputProps['onChange'] = (event, child) =>
    handleChangeFormSelectField(fieldConfig, event, child, onChange);
  const handleBlur = (event: React.FocusEvent<HTMLInputElement>) =>
    handleBlurFormField(fieldConfig, event, onBlur);
  const hasError = checkFormHasError(meta);

  // Destructuring out onChange and onBlur to prevent them from being declared twice on TextField
  const trimmedFieldConfig = omit(fieldConfig, ['onChange', 'onBlur']);

  return (
    <SelectField
      error={hasError}
      showPlaceholderStyles={!fieldConfig.value}
      helperText={!hasError ? helperText : meta.error}
      onChange={handleChange}
      onBlur={handleBlur}
      id={idValue}
      {...trimmedFieldConfig}
      {...rest}
    >
      {children}
    </SelectField>
  );
};

export default FormSelectField;
